export default class Modal {
	static init() {
		new Modal();
	}

	constructor() {
		window.addEventListener('click', (e) => {
			const modalLink = e.target.dataset.toggle === "modal" ? e.target : false;
			const modalClose = e.target.classList.contains('modal__close') ? e.target : false;
			const modalBackdrop = e.target.classList.contains('modal__backdrop') ? e.target : false;

			if (modalLink) {
				let modal = document.querySelector(modalLink.dataset.target);

				if (modal) {
					modal.classList.add('visible');
				}
			}

			if (modalClose) {
				let modal = modalClose.closest('.modal')
				modal.classList.remove('visible');
			}

			if (modalBackdrop) {
				let modal = modalBackdrop.closest('.modal');
				modal.classList.remove('visible');
			}
		});
	}
}
